export const UPDATE_RATING_FAILURE = 'UPDATE_RATING_FAILURE';

export const updateRatingFailure = error => ({
    type: UPDATE_RATING_FAILURE,
    payload: error,
    error: true,
});
